import { Typography } from '@mui/material';
import { Flex } from '../../../../base/components/Flex';
import { useTranslationPrefix } from '../../../../hooks/useTranslationPrefix';
import QrButton from '../components/QrButton';
import QrPageLogo from '../components/QrPageLogo';

interface Props {
  onNextClick: () => void;
}

const QrWelcomeStep = ({ onNextClick }: Props) => {
  const { _t } = useTranslationPrefix('LaunchPlaylistQrPageNew');

  return (
    <Flex
      flexDirection="column"
      width="100%"
      minHeight="100%"
      alignItems="center"
      justifyContent="space-evenly"
    >
      <Flex flexDirection="column" alignItems="center" gap={{ xs: 4, md: 8 }}>
        <QrPageLogo
          sx={{
            maxWidth: { md: '500px' },
            maxHeight: { md: '300px' },
            mx: 'auto',
          }}
        />

        <QrButton id="start-training" color="success" onClick={onNextClick}>
          {_t('startTraining', 'Start Training')}
        </QrButton>
        <Typography
          fontSize={{ xs: '2.5rem', md: '4rem' }}
          lineHeight="normal"
          fontWeight="600"
        >
          {_t('hashtag', '#mocPOmoc')}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default QrWelcomeStep;
